import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Card, Text } from '../ui/index.js';
import type { AuditEntry } from '@goodbuild/shared';
import { api } from '../api/client.js';
import { keys, useAccess } from '../api/hooks.js';
import { EmptyState, Loading } from '../components/layout/Loading.js';
import { formatRelative } from '../lib/format.js';

export const Route = createFileRoute('/admin/audit')({ component: AdminAudit });

/**
 * The audit log.
 *
 * Every write that touches Access, crews, roles, builds or creators is here, including the ones
 * the system did on its own, which show no actor.
 */
function AdminAudit() {
  const { isAdmin } = useAccess();

  const { data, isLoading } = useQuery({
    queryKey: keys.admin.audit,
    queryFn: () => api.get<{ items: AuditEntry[]; cursor: string | null }>('/admin/audit'),
    enabled: isAdmin,
  });

  if (!isAdmin) return <EmptyState title={'You cannot do that.'} />;
  if (isLoading) return <Loading />;

  const rows = data?.items ?? [];
  if (rows.length === 0) return <EmptyState title={'None'} />;

  return (
    <div className="gb-stack">
      {rows.map((entry) => (
        <Card key={entry.id} size="1">
          <div className="gb-seat">
            <Text size="2">{entry.action}</Text>
            <Text size="1" color="gray">
              {entry.actor?.username ?? 'GOOD BUILD'}
            </Text>
            <span className="gb-seat__spacer" />
            <Text size="1" color="gray">
              {entry.targetType} {entry.targetId.slice(0, 12)}
            </Text>
            <Text size="1" color="gray">
              {formatRelative(entry.createdAt)}
            </Text>
          </div>
        </Card>
      ))}
    </div>
  );
}
